import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import envelope from 'assets/img/icons/spot-illustrations/16.png';
import paths from 'routes/paths';

const loginPaths = {
  simple: paths.simpleLogin,
  split: paths.splitLogin,
  card: paths.cardLogin
};

const ConfirmMailContent = ({
  link,
  layout = 'simple',
  titleTag: TitleTag = 'h4'
}) => {
  return (
    <>
      <TitleTag>Vaš nalog je uspešno aktiviran</TitleTag>
      <p>
          Hvala što ste potvrdili svoju registraciju. Sada možete da se prijavite i počnete da koristite našu uslugu..
      </p>
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="mt-3"
        to={link}
      >
        <FontAwesomeIcon
          icon="chevron-left"
          transform="shrink-4 down-1"
          className="me-1"
        />
        Unesi lozinku
      </Button>
    </>
  );
};

ConfirmMailContent.propTypes = {
  email: PropTypes.string.isRequired,
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

export default ConfirmMailContent;
